import styled, { keyframes } from 'styled-components'

const onEnter = keyframes`
  0% {
   scale: 0;
  }

  100% {
    scale: 1;
  }
`

export const Overlay = styled.div`
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 9999;

  display: flex;
  align-items: center;
  justify-content: center;

  background: rgba(0, 0, 0, 0.65);
`

export const Container = styled.div`
  width: ${({ size }) =>
    size === 'small' ? '615px' : size === 'medium' ? '820px' : '1230px'};
  height: ${({ size }) =>
    size === 'small' ? '280px' : size === 'medium' ? '373px' : '560px'};

  border-radius: 15px;
  background: #c0c5c1;

  display: flex;
  flex-direction: column;

  animation: ${onEnter} 0.3s forwards;
`

export const Header = styled.header`
  padding: 10px;
  min-height: 30px;

  h1 {
    all: unset;
    margin: 0;
    font-size: 20px;
    font-weight: bold;
  }

  button {
    all: unset;
    position: absolute;
    right: 0;
    top: 0;
    margin: 0 5px;
    cursor: pointer;
  }
`

export const Content = styled.main`
  padding: 20px;
  flex: 1;
  max-height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
`
